<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
      @keydown.esc="closeDialog"
    >
      <v-toolbar fixed dark :color="color">
        <v-toolbar-title class="pl-3">{{ $capitalizeFirstLetter(action) }} {{title}}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <v-btn
            icon
            :loading="loading"
            :disabled="loading || disableSave"
            v-if="showSave"
            @click="saveDialog"
            class="mr-3"
            slot="activator"
          >
            <v-icon>save</v-icon>
          </v-btn>
          <span>Save</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn icon @click.native="closeDialog()" class="mr-3" slot="activator">
            <v-icon>close</v-icon>
          </v-btn>
          <span>Close</span>
        </v-tooltip>
      </v-toolbar>
      <v-card style="position: absolute; top: 0; left: 0;">
        <v-card-text class="my-5 pa-4">
          <v-container fill-height v-if="loading">
            <v-layout align-center justify-center>
              <v-progress-circular :size="40" :width="3" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
          <slot v-else></slot>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    dialog: Boolean,
    action: String,
    color: String,
    showSave: Boolean,
    loading: Boolean,
    disableSave: Boolean
  },
  data() {
    return {};
  },
  methods: {
    saveDialog() {
      this.$emit("saveDialog");
    },
    saveConfirmDialog() {
      this.$emit("saveConfirmDialog");
    },
    openDialog() {
      this.$emit("openDialog");
    },
    closeDialog() {
      this.$emit("closeDialog");
      //   this.$clearTempData();
    },
    closeConfirmDialog() {
      this.$emit("closeConfirmDialog");
    }
  }
};
</script>

<style>
</style>
